export default {
  mode: '',
  publicationId:'',
}